import ReactDOM from 'react-dom';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface AssetShareFormState {
  label: string;
  hours: number;
  maxViews: number;
}

interface AssetShareCreateModalProps {
  open: boolean;
  form: AssetShareFormState;
  loading: boolean;
  t: Translate;
  onClose: () => void;
  onFormChange: (form: AssetShareFormState) => void;
  onSubmit: () => void;
}

export default function AssetShareCreateModal({
  open,
  form,
  loading,
  t,
  onClose,
  onFormChange,
  onSubmit,
}: AssetShareCreateModalProps) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div onClick={event => event.stopPropagation()} style={{ background: 'var(--surface)', borderRadius: 'var(--radius)', padding: '1.5rem', width: '340px', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <h3 style={{ margin: '0 0 1rem 0', fontSize: '1rem' }}>{t('assetShare.createTitle')}</h3>
        <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.85rem' }}>
          {t('assetShare.labelField')} <span style={{ color: 'var(--danger)' }}>*</span>
          <input
            type="text"
            placeholder={t('assetShare.labelPlaceholder')}
            value={form.label}
            onChange={event => onFormChange({ ...form, label: event.target.value })}
            style={{ display: 'block', width: '100%', marginTop: '0.3rem', padding: '0.4rem 0.5rem', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '0.85rem', boxSizing: 'border-box' }}
          />
        </label>
        <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.85rem' }}>
          {t('assetShare.hoursField')}
          <input
            type="number"
            min={1}
            max={720}
            value={form.hours}
            onChange={event => onFormChange({ ...form, hours: parseInt(event.target.value) || 1 })}
            style={{ display: 'block', width: '100%', marginTop: '0.3rem', padding: '0.4rem 0.5rem', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '0.85rem', boxSizing: 'border-box' }}
          />
        </label>
        <label style={{ display: 'block', marginBottom: '1rem', fontSize: '0.85rem' }}>
          {t('assetShare.maxViewsField')}
          <input
            type="number"
            min={0}
            max={9999}
            value={form.maxViews}
            onChange={event => onFormChange({ ...form, maxViews: parseInt(event.target.value) || 0 })}
            style={{ display: 'block', width: '100%', marginTop: '0.3rem', padding: '0.4rem 0.5rem', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '0.85rem', boxSizing: 'border-box' }}
          />
          <span style={{ fontSize: '0.75rem', color: 'var(--text-3)' }}>{t('assetShare.maxViewsHint')}</span>
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" style={{ fontSize: '0.8rem' }} onClick={onClose}>{t('cancel', { ns: 'common' })}</button>
          <button
            className="btn btn-primary"
            style={{ fontSize: '0.8rem' }}
            disabled={!form.label.trim() || loading}
            onClick={onSubmit}
          >
            {loading ? t('assetShare.generatingEllipsis') : t('assetShare.generateAndCopy')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
